import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "integral-setting-page" }
const _hoisted_2 = { class: "setting-header-card" }
const _hoisted_3 = { class: "card-left" }
const _hoisted_4 = { class: "icon-avatar" }
const _hoisted_5 = { class: "card-right" }
const _hoisted_6 = { class: "form-section-block" }
const _hoisted_7 = { class: "form-section-block" }
const _hoisted_8 = { class: "score-calculation-card" }
const _hoisted_9 = { class: "calc-header" }
const _hoisted_10 = { class: "calc-display-box" }
const _hoisted_11 = { class: "formula-process" }
const _hoisted_12 = { class: "term-box" }
const _hoisted_13 = { class: "num-badge" }
const _hoisted_14 = { class: "term-box" }
const _hoisted_15 = { class: "num-badge" }
const _hoisted_16 = { class: "term-box" }
const _hoisted_17 = { class: "num-badge" }
const _hoisted_18 = { class: "total-score-value" }
const _hoisted_19 = { class: "score-number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Medal = _resolveComponent("Medal")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Check = _resolveComponent("Check")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[34] || (_cache[34] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_Medal)
            ]),
            _: 1
          })
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-group" }, [
          _createElementVNode("h2", { class: "title" }, "积分管理"),
          _createElementVNode("span", { class: "sub-text" }, "根据游戏难度自动计算基础分，配置过关奖励及答错/求助惩处机制")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          type: "primary",
          class: "top-save-btn",
          loading: _ctx.saving,
          onClick: _ctx.saveSettings
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_Check)
              ]),
              _: 1
            }),
            _cache[11] || (_cache[11] = _createTextVNode(" 保存 ", -1))
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ]),
    _createVNode(_component_el_form, {
      model: _ctx.form,
      "label-width": "auto",
      "label-position": "top",
      class: "integral-main-form"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "section-title-row" }, [
            _createElementVNode("span", { class: "indicator-bar" }),
            _createElementVNode("span", { class: "section-name" }, "时间与基础得分机制"),
            _createElementVNode("span", { class: "section-hint" }, "基础分随难度锁定联动（不可手动更改）")
          ], -1)),
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "游戏标准时长" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "number",
                        modelValue: _ctx.form.gameTime,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.gameTime) = $event)),
                        disabled: "",
                        placeholder: "0"
                      }, {
                        append: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createTextVNode("分钟", -1)
                        ]))]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "基础分（根据游戏难度自动设定）" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "number",
                        modelValue: _ctx.form.fullMarks,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.fullMarks) = $event)),
                        disabled: "",
                        placeholder: "根据难度联动"
                      }, {
                        append: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                          _createTextVNode("分", -1)
                        ]))]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "多长时间内过关获得基础分（分钟）" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "number",
                        min: "0",
                        clearable: "",
                        modelValue: _ctx.form.parlayTime,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.parlayTime) = $event)),
                        modelModifiers: { number: true },
                        placeholder: "建议根据关卡总数折算"
                      }, {
                        append: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createTextVNode("分钟内", -1)
                        ]))]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "每过一关积分奖励" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "number",
                        min: "0",
                        clearable: "",
                        modelValue: _ctx.form.levelPoints,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.levelPoints) = $event)),
                        modelModifiers: { number: true },
                        placeholder: "建议设为 100 分每关",
                        onInput: _ctx.handleLevelPointsChange
                      }, {
                        append: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createTextVNode("分/关", -1)
                        ]))]),
                        _: 1
                      }, 8, ["modelValue", "onInput"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "section-title-row" }, [
            _createElementVNode("span", { class: "indicator-bar warning" }),
            _createElementVNode("span", { class: "section-name" }, "惩处与消耗扣分机制"),
            _createElementVNode("span", { class: "section-hint" }, "试错、求助与跳过扣分机制配置")
          ], -1)),
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "超时扣分" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "number",
                        min: "0",
                        clearable: "",
                        modelValue: _ctx.form.timeoutDeducted,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.timeoutDeducted) = $event)),
                        modelModifiers: { number: true },
                        placeholder: "0"
                      }, {
                        append: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                          _createTextVNode("分", -1)
                        ]))]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "每次答错扣分" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "number",
                        min: "0",
                        clearable: "",
                        modelValue: _ctx.form.incorrectAnswer,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.incorrectAnswer) = $event)),
                        modelModifiers: { number: true },
                        placeholder: "建议设为 10 到 20 分"
                      }, {
                        append: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                          _createTextVNode("分/次", -1)
                        ]))]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "使用提示扣分" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "number",
                        min: "0",
                        clearable: "",
                        modelValue: _ctx.form.promptsDeduct,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.promptsDeduct) = $event)),
                        modelModifiers: { number: true },
                        placeholder: "建议设为 50 分"
                      }, {
                        append: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                          _createTextVNode("分/次", -1)
                        ]))]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "跳过关卡扣分（自动关联过关积分奖励）" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "number",
                        modelValue: _ctx.form.skippingParlay,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.skippingParlay) = $event)),
                        disabled: "",
                        placeholder: "与每过一关积分奖励一致"
                      }, {
                        append: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                          _createTextVNode("分/关", -1)
                        ]))]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "使用 GPS 定位帮助扣分" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "number",
                        min: "0",
                        clearable: "",
                        modelValue: _ctx.form.sosPoints,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.sosPoints) = $event)),
                        modelModifiers: { number: true },
                        placeholder: "建议设为 50 分"
                      }, {
                        append: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                          _createTextVNode("分/次", -1)
                        ]))]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "关卡数量" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "number",
                        modelValue: _ctx.form.numberLevel,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.numberLevel) = $event)),
                        disabled: "",
                        placeholder: "0"
                      }, {
                        append: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                          _createTextVNode("关", -1)
                        ]))]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "calc-header-left" }, [
              _createElementVNode("span", { class: "calc-title-prominent" }, "游戏最高得分"),
              _createElementVNode("span", { class: "calc-formula-desc" }, "计算公式：基础分 + 关卡数 × 每过一关积分奖励")
            ], -1)),
            _createVNode(_component_el_tag, {
              type: "info",
              effect: "plain",
              class: "rule-tag"
            }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createTextVNode("理论上限", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "term-label" }, "基础分", -1)),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.form.fullMarks || 0), 1)
              ]),
              _cache[29] || (_cache[29] = _createElementVNode("span", { class: "operator" }, "+", -1)),
              _createElementVNode("div", _hoisted_14, [
                _cache[27] || (_cache[27] = _createElementVNode("span", { class: "term-label" }, "关卡数", -1)),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.form.numberLevel || 0), 1)
              ]),
              _cache[30] || (_cache[30] = _createElementVNode("span", { class: "operator" }, "×", -1)),
              _createElementVNode("div", _hoisted_16, [
                _cache[28] || (_cache[28] = _createElementVNode("span", { class: "term-label" }, "过关奖励", -1)),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.form.levelPoints || 0), 1)
              ]),
              _cache[31] || (_cache[31] = _createElementVNode("span", { class: "operator" }, "=", -1))
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[32] || (_cache[32] = _createElementVNode("span", { class: "label" }, "最高得分封顶", -1)),
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.totalPoint || 0), 1),
              _cache[33] || (_cache[33] = _createElementVNode("span", { class: "unit" }, "分", -1))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model"]),
    _cache[35] || (_cache[35] = _createElementVNode("div", { class: "zhanwei3" }, null, -1))
  ]))
}